import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { SessionKey } from '../enums/session-key.enum';
import { AppStoreService } from '../store/app-store.service';
import { AuthService } from './auth.service';
import { LanguageService } from './language.service';
import { SessionService } from './session.service';
import { StorageType } from '../enums/storage-type.enum';
import { Configuration } from '@core/api';
import { MatIconRegistry } from '@angular/material/icon';
import { UserProfileService } from './user-profile.service';

@Injectable({
    providedIn: 'root',
})
export class AppInitService {
    private readonly _appStoreService = inject(AppStoreService);
    private readonly _sessionService = inject(SessionService);
    private readonly _translate = inject(TranslateService);
    private readonly _authService = inject(AuthService);
    private readonly _languageService = inject(LanguageService);
    // private readonly _http = inject(HttpClient);
    private readonly _config = inject(Configuration);
    private readonly _iconRegistry = inject(MatIconRegistry);
    private readonly _userProfileService = inject(UserProfileService);

    constructor() {}

    async init(): Promise<void> {
        this.setMatIcons();
        const basePath = this._config.basePath;

        // OpenAPI.BASE = environment.backendBaseUrl;
        console.log('API URL: ', basePath);

        const sessionError = this._sessionService.startSession();

        await this.initTranslate();

        if(sessionError != null){
            this._authService.logout(sessionError);
        }
        else{
            const token = this._appStoreService.token();
            // preAuth
            if(token != null && (token.preAuth === undefined || token.preAuth === false)){
                await this._userProfileService.setUserProfile();
            }
        }

        // const ipAddress = await this.retrieveIpAddress();
        // await this.spinnerTest(10000);
    }

    private async initTranslate(): Promise<void> {
        try {
            await this.getLanguages();
            this._translate.addLangs(this._appStoreService.languageList());

            // a böngésző nyelvéhez próbál igazodni
            const browserLang = this._translate.getBrowserLang() && this._translate.getLangs().includes(this._translate.getBrowserLang()!) ? this._translate.getBrowserLang() : 'hu';
            const lang = this._sessionService.getItem(SessionKey.LANG, StorageType.LOCAL) ?? browserLang;

            this._translate.setFallbackLang(lang!);
            this._translate.use(lang!);
            this._sessionService.setItem(SessionKey.LANG, lang!, StorageType.LOCAL);
            // this._appStoreService.setLang(lang!);
        } 
        catch (error) {}
    }

    private async getLanguages(): Promise<string[]> {
        return lastValueFrom(this._languageService.getLanguages())
            .then(
                (languageList: string[]) => {
                    this._appStoreService.setLanguageList(languageList);
                    return Promise.resolve(languageList);
                }
            )
            .catch((error) => {
                return Promise.reject();
            });
    }

  // ---------------------------------------------------------------------

    // private async retrieveIpAddress(): Promise<any> {
    //     return lastValueFrom(this._http.get('http://api.ipify.org/?format=json'))
    //         .then(function (response: any) {
    //             return Promise.resolve(response.ip);
    //         })
    //         .catch((error) => {
    //             //   return Promise.reject();
    //             return Promise.resolve('');
    //         });
    // }

    // private async spinnerTest(ms: number): Promise<string>{
    //     return lastValueFrom(
    //         of('spinner test').pipe(
    //             delay(ms)
    //         ))
    //             .then(function (text: string) {
    //                 return Promise.resolve(text);
    //             });
    // }

    private setMatIcons(){
        this._iconRegistry.setDefaultFontSetClass('material-symbols-outlined');
    }
}
